module.exports = __webpack_public_path__ + "static/media/dentistry.d3c700d9.svg";